import { defineComponent } from 'vue'
import { useWindows } from './hooks/useWindows'

export const WindowManager = defineComponent(() => {
  const manager = useWindows();
  
  return () => {
    return (
      <div
        style={{
          width: '100vw',
          height: '100vh',
          zIndex: 99999,
          position: 'fixed',
          top: 0,
          left: 0,
          pointerEvents: 'none'
        }}
      >
        {manager.windows.value.map(win => {
          return win.rendered.value;
        })}
      </div>
    )
  }
})
